var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "d-flex flex-row align-items-center" }, [
      _c("div", { staticClass: "d-flex justify-content-start" }, [
        _c("div", { staticClass: "p-1" }),
        _vm._v(" "),
        _c("div", { staticClass: "pl-0 pt-1 pr-1 pb-1" }, [
          _c(
            "div",
            { staticClass: "text-bold-600", staticStyle: { color: "inherit" } },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.company.name) +
                  "\n                "
              ),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "p-1 ml-auto" }, [
        _c(
          "button",
          {
            staticClass: "btn waves-effect waves-light btn-sm",
            class: {
              "btn-success": !_vm.isAssignedToOrganisation,
              "btn-danger": _vm.isAssignedToOrganisation,
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.toggleAssignment.apply(null, arguments)
              },
            },
          },
          [
            _vm._v(
              "\n                " +
                _vm._s(_vm.assignmentButtonText) +
                "\n            "
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }